import { render, staticRenderFns } from "./SortByClass.vue?vue&type=template&id=24cea3d3&"
import script from "./SortByClass.vue?vue&type=script&lang=ts&"
export * from "./SortByClass.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports